/* eslint-disable indent */
import React, { useState, useEffect, useMemo } from "react";
import { Menu, Row, Col, Layout, Spin, message, Empty } from "antd";
import {
  UserOutlined,
  FileTextOutlined,
  BankOutlined,
  DollarOutlined,
} from "@ant-design/icons";
//import RateCardMatrix from "../views/DynamicRateCard/DynamicRateCardMatrix";
import { useParams, useLocation } from "react-router";
import DetailsViewer from "./MenuLayotView";
import Heading from "./Heading";
import { customerOnboardingAPI } from "../api/LeadApi";
import CompanyListWithDetails from "../views/Master/MasterLists/CompanyListWithDetails";
import "./customerDetails.scss";
import CustomerApprovalAction from "./CustomerApprovalAction";
import urls from "../api/urls";
import API from "../api";
import CashRateCard from "../views/RateCalculator/CashRateCard";
const { Sider, Content } = Layout;
const { GET_CLIENT_MASTER_LIST_V1, GET_RATE_CARD_QUOTATION } = urls;

const CustomerDetails = () => {
  const { id } = useParams();
  const [selectedMenu, setSelectedMenu] = useState("basic");
  const [loading, setLoading] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({});
  const [data, setData] = useState({});
  const [rateCardDetails, setRateCardDetails] = useState({});
  const history = useLocation();

  const [actionEdit, setActionEdit] = useState(false);
  //const [isEdit, setIsEdit] = useState(false);

  const MENU_CONFIG = {
    CP: [
      { key: "basic", icon: <UserOutlined />, label: "Basic Details" },
      { key: "company", icon: <BankOutlined />, label: "Company Details" },
      {
        key: "ratecard",
        icon: <DollarOutlined />,
        label: "Rate Card Details",
      },
      //{ key: "defaultCompany", icon: <BankOutlined />, label: "Company Details" },
      { key: "bankDetail", icon: <BankOutlined />, label: "Bank Details" },
      {
        key: "agreement",
        icon: <FileTextOutlined />,
        label: "Agreement Details",
      },
      {
        key: "document",
        icon: <FileTextOutlined />,
        label: "Document Details",
      },
      {
        key: "branding",
        icon: <FileTextOutlined />,
        label: "Branding Details",
      },
    ],
    CLIENT: [
      {
        key: "organisation",
        icon: <UserOutlined />,
        label: "Organisation Details",
        isEdit: history?.state?.basicEdit,
        apiUrl: GET_CLIENT_MASTER_LIST_V1,
      },
      {
        key: "ratecard",
        icon: <DollarOutlined />,
        label: "Rate Card Details",
      },
      {
        key: "business",
        icon: <BankOutlined />,
        label: "Business Details",
        isEdit: history?.state?.basicEdit,
        apiUrl: GET_CLIENT_MASTER_LIST_V1,
      },
      {
        key: "agreement",
        icon: <FileTextOutlined />,
        label: "Agreement Details",
      },
      {
        key: "document",
        icon: <FileTextOutlined />,
        label: "Document Details",
      },
    ],
    COMPANY: [
      { key: "basicCompany", icon: <UserOutlined />, label: "Basic Details" },
      { key: "bankDetail", icon: <BankOutlined />, label: "Bank Details" },
      {
        key: "agreement",
        icon: <FileTextOutlined />,
        label: "Agreement Details",
      },
      {
        key: "document",
        icon: <FileTextOutlined />,
        label: "Document Details",
      },
    ],
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, []);
  const fetchCustomerDetails = async () => {
    try {
      setLoading(true);

      const response = await customerOnboardingAPI.getMasterById(
        id,
        history?.state?.apiUrl
      );
      if (!response.status)
        throw new Error(response?.response?.data?.message || "Network error");

      const customerData = response.response.data;
      setCustomerInfo(customerData);
      setData(formatCustomerDetails(customerData));

      // Set default selected menu
      const customerType = customerData?.customerType?.toUpperCase();
      const menuMapping = {
        CLIENT: "organisation",
        CP: "basic",
        COMPANY: "basicCompany",
      };

      setSelectedMenu(menuMapping[customerType] || "");
      if (customerData?.quotations?.length > 0) {
        let quotation = customerData?.quotations[0];

        let showApprove = quotation?.status?.toUpperCase() === "PENDING";
        const res = await API.Api(
          GET_RATE_CARD_QUOTATION +
            quotation?.rateCardName +
            "?includeOld=" +
            showApprove
        ).get();
        if (res.status) {
          setRateCardDetails(res.response.data);
        } else {
          message.error(res.response.data.message || "Internal server error");
        }
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatCustomerDetails = (customerData) => {
    const {
      businessDetail,
      kycDocuments,
      agreements,
      addresses,
      documents,
      bankDetails,
      contactNumbers,
      contacts,
      metadata,
      emails,
    } = customerData;

    const getIdNumber = (idType) =>
      kycDocuments?.find((doc) => doc.idType === idType)?.idNumber;
    const cpType = metadata?.find((e) => e?.key === "CP_TYPE")?.value;
    const defaultAddress = addresses?.find(
      (e) => e.type?.toUpperCase() === "DEFAULT"
    );
    const collectionAddress = addresses?.find(
      (e) => e.type?.toUpperCase() === "COLLECTION"
    );
    const billingAddress = addresses?.find(
      (e) => e.type?.toUpperCase() === "BILLING"
    );
    const mobileNumber = contactNumbers?.find(
      (e) => e.type?.toUpperCase() === "DEFAULT"
    )?.number;
    const emailId = emails?.find(
      (e) => e.type?.toUpperCase() === "DEFAULT"
    )?.email;

    const brandingDocuments = documents?.filter(
      (item) => item?.type === "BRANDING"
    );

    const onlyDocuments = documents?.filter(
      (item) => item?.type !== "BRANDING"
    );

    return {
      basic: {
        cpName: customerData.organizationName || customerData.orgName,
        cpType: cpType,
        CreatedBy: customerData.createdByName,
        nameOfOwner: businessDetail?.nameOfOwner,
        phoneNumber: contactNumbers?.[0]?.number,
        emailId: customerData.emails?.[0]?.email,
        address: `${defaultAddress?.street || ""}, ${
          defaultAddress?.city || ""
        }, ${defaultAddress?.state || ""}, ${defaultAddress?.pincode || ""}`,
      },
      company: {
        companyName: businessDetail?.companyName,
        gstNo: getIdNumber("GST"),
        panNumber: getIdNumber("PAN"),
        aadharNo: getIdNumber("AADHAR"),
        tanNo: getIdNumber("TAN"),
        address: `${defaultAddress?.street || ""}, ${
          defaultAddress?.city || ""
        } ${defaultAddress?.pincode || ""}`,
        businessType: businessDetail?.natureOfBusiness,
        businessName: businessDetail?.businessName,
      },
      defaultCompany: {
        companyName: businessDetail?.companyName,
        gstNo: getIdNumber("GST"),
        panNumber: getIdNumber("PAN"),
        aadharNo: getIdNumber("AADHAR"),
        tanNo: getIdNumber("TAN"),
        address: `${defaultAddress?.street || ""}, ${
          defaultAddress.line2 || ""
        } ${defaultAddress?.pincode || ""}`,
        businessType: businessDetail?.natureOfBusiness,
        businessName: businessDetail?.businessName,
      },
      bankDetail: bankDetails?.reduce((acc, item) => {
        acc["accountHolderName"] = item.accountHolderName;
        acc["accountNumber"] = item.accountNumber;
        acc["ifscCode"] = item.ifscCode;
        return acc;
      }, {}),

      organisation: {
        clientName: customerData.organizationName || customerData.orgName,
        CreatedBy: customerData.createdByName,
        mobileNumber: mobileNumber,
        emailId: emailId,
        gstNo: getIdNumber("GST"),
        panNumber: getIdNumber("PAN"),
        aadharNo: getIdNumber("AADHAR"),
        tanNo: getIdNumber("TAN"),
        address: `${defaultAddress?.street || ""} ${
          defaultAddress?.area || ""
        } ${defaultAddress?.city || ""} ${defaultAddress?.state || ""} ${
          defaultAddress?.pincode || ""
        }`,
      },
      business: {
        contactName: contacts?.[0]?.personName,
        designation: contacts?.[0]?.designation,
        department: businessDetail?.businessName,
        //natureOfBusiness: businessDetail?.natureOfBusiness ,
        pickupTime: businessDetail?.pickupTime,

        businessType: businessDetail?.natureOfBusiness,
        businessName: "N/A",
        committedBusiness: businessDetail?.turnOver,
        billingAddress: `${billingAddress?.street || ""} ${
          billingAddress?.city || ""
        }, ${billingAddress?.state || ""}, ${billingAddress?.pincode || ""}`,
        collectionAddress: `${collectionAddress?.street || ""} ${
          collectionAddress?.city || ""
        }, ${collectionAddress?.state || ""}, ${
          collectionAddress?.pincode || ""
        }`,
      },
      basicCompany: {
        CompanyName: customerData.organizationName || customerData.orgName,
        CreatedBy: customerData?.createdByName,
        nameOfOwner: businessDetail?.nameOfOwner,
        phoneNumber: contactNumbers?.[0]?.number,
        emailId: customerData?.emails?.[0]?.email,
        gstNo: getIdNumber("GST"),
        panNumber: getIdNumber("PAN"),
        aadharNo: getIdNumber("AADHAR"),
        tanNo: getIdNumber("TAN"),
        address: `${defaultAddress.line1 || ""}, ${
          defaultAddress?.city || ""
        }, ${defaultAddress?.state || ""}, ${defaultAddress?.pincode || ""}`,
      },
      agreement: agreements?.map(({ agreementDetails }) => ({
        value: agreementDetails,
      })),
      document: onlyDocuments?.map(({ docType, fileLocationUrl }) => ({
        label: docType,
        value: fileLocationUrl?.split("/").pop(),
        type: "link",
        linkUrl: fileLocationUrl,
      })),
      branding: brandingDocuments?.map(({ docType, fileLocationUrl }) => ({
        label: docType,
        value: fileLocationUrl?.split("/").pop(),
        type: "link",
        linkUrl: fileLocationUrl,
      })),
      bankDetails: bankDetails.reduce((acc, item, i) => {
        acc[`Account ${i + 1} Name`] = item.accountHolderName;
        acc[`Account ${i + 1} Number`] = item.accountNumber;
        acc[`IFSC Code ${i + 1}`] = item.ifscCode;
        return acc;
      }, {}),
    };
  };

  const menuItems = useMemo(
    () => MENU_CONFIG[customerInfo?.customerType?.toUpperCase()] || [],
    [customerInfo]
  );

  // if (!data || Object.keys(data).length === 0) {
  //   return (
  //     <div className="center">
  //       <Empty />
  //     </div>
  //   );
  // }

  console.log(rateCardDetails, "rateCardDetails");
  return (
    <div className="p-1">
      <Heading
        title={`${history?.state?.heading || "Details"} (${
          customerInfo?.organizationName || customerInfo?.orgName || ""
        })`}
        navigateTo={history?.state?.reRoute}
        id={history?.state?.tabKey}
        extraContent={
          history?.state?.actionPresent && (
            <CustomerApprovalAction
              leadDetails={customerInfo}
              navigateTo={history?.state?.reRoute}
              navigateId={history?.state?.tabKey}
              setLoading={(val) => setLoading(val)}
              fetchData={fetchCustomerDetails}
            />
          )
        }
      />
      {data || Object.keys(data).length > 0 ? (
        <Spin spinning={loading}>
          <Layout
            style={{
              //minHeight: "100vh",
              backgroundColor: "#f0f2f5",
              padding: 20,
              width: "100%",
            }}
            className="details-menu"
          >
            <Row gutter={24} style={{ width: "100%" }}>
              {/* Sidebar Navigation */}

              <Col xs={24} sm={8} md={5} lg={5} xl={5}>
                <Sider
                  width="100%"
                  style={{
                    background: "#fff",
                    borderRadius: 10,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <Menu
                    selectedKeys={[selectedMenu]}
                    onClick={(e) => setSelectedMenu(e.key)}
                    style={{ borderRadius: 10 }}
                  >
                    {menuItems.map((item) => (
                      <Menu.Item key={item.key} icon={item.icon}>
                        {item.label}
                      </Menu.Item>
                    ))}
                  </Menu>
                </Sider>
              </Col>

              {/* Content Section */}
              <Col xs={24} sm={16} md={19} lg={19} xl={19}>
                <Content>
                  {selectedMenu === "company" &&
                  !history?.state?.actionPresent &&
                  !history?.state?.companyDetailview ? (
                    <CompanyListWithDetails
                      userType={"COMPANY"}
                      cpId={history?.state?.cpId}
                    />
                  ) : selectedMenu === "ratecard" ? (
                    <CashRateCard
                      data={rateCardDetails}
                      showValueChangedPercentage={true}
                      actionEdit={false}
                      disableNewWeightSlabs={true}
                      showAddRateMatrix={false}
                      showComittedBusiness={true}
                      showInvoiceType={false}
                      showHighLight={true}
                    />
                  ) : (
                    <DetailsViewer
                      title={
                        menuItems.find((item) => item.key === selectedMenu)
                          ?.label
                      }
                      data={data[selectedMenu]}
                      actionEdit={actionEdit}
                      isEdit={
                        menuItems.find((item) => item.key === selectedMenu)
                          ?.isEdit
                      }
                      handleEdit={() => {
                        setActionEdit(!actionEdit);
                      }}
                      getData={customerInfo}
                      apiUrl={
                        menuItems.find((item) => item.key === selectedMenu)
                          ?.apiUrl
                      }
                      menukey={
                        menuItems.find((item) => item.key === selectedMenu)?.key
                      }
                      fetchData={fetchCustomerDetails}
                      customerId={id}
                    />
                  )}
                </Content>
              </Col>

              {/* <Col span={24} className="flex-end mt-2">
                {history?.state?.actionPresent && (
                  <CustomerApprovalAction
                    leadDetails={customerInfo}
                    navigateTo={history?.state?.reRoute}
                    navigateId={history?.state?.tabKey}
                    setLoading={(val) => setLoading(val)}
                  />
                )}
              </Col> */}
            </Row>
          </Layout>
        </Spin>
      ) : (
        <div className="center">
          <Empty />
        </div>
      )}
    </div>
  );
};

export default CustomerDetails;
